import React from 'react'
import Combaintop from '../Components/Combaintop/Top';
import Combainbottom from '../Components/Combainbottom/Combainbottom';
import Breadcrumbs from '../Components/banner/New-banner';
import Privacy from '../Components/Privacy/privacy';
function Privacypage() {
    return (

        <>
            <Combaintop />
            <Breadcrumbs />
            <Privacy />
            <Combainbottom />
        </>
    );
}

export default Privacypage
